import React from "react";
import LTStatistics from "./DBSections/LT_Statistics";
import VolStatistics from "./DBSections/Vol_Statistics";
import OthStatistics from "./DBSections/Oth_Statistics";

export interface IDBComponentProps {
  dbData: any;
  downloadDbReports: (rpTyp: string) => void;
}

const DBComponent: React.FC<IDBComponentProps> = (props) => {
  return (
    <div>
      {/* Login Vs Trading Statistics */}
      <div id="Login-vs-trading" className="lts_container">
        <h3 className="Section_heading">Login Vs Trading Statistics</h3>
        <LTStatistics
          dbData={props.dbData}
          downloadDbReports={props.downloadDbReports}
        />
      </div>
      <div id="volume-statistics" className="v_container">
        <h3 className="Section_heading">Volume Statistics</h3>
        <VolStatistics
          dbData={props.dbData}
          downloadDbReports={props.downloadDbReports}
        />
      </div>
      <div id="other-statistics" className="oth_container">
        <h3 className="Section_heading">Other Statistics</h3>
        <OthStatistics dbData={props.dbData} />
      </div>
    </div>
  );
};

export default DBComponent;
